import * as React from 'react';
import CharmSize from '../utils/CharmSize';
import FlagStatus from 'owa-service/lib/contract/FlagStatus';
import hasCharmlessInfoBars from '../utils/hasCharmlessInfoBars';
import isMessageLiked from '../utils/isMessageLiked';
import ItemViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemViewState';
import loc from 'owa-localize';
import { ClientMessage, InstrumentationContext } from 'owa-mail-store';
import { ControlIcons } from 'owa-control-icons';
import { createInfoBarViewState } from 'owa-mail-reading-pane-infobar';
import { Icon } from '@fluentui/react/lib/Icon';
import { observer, useComputed } from 'mobx-react-lite';
import {
    infoFlagForFollowUp,
    infoHighImportance,
    infoLowImportance,
} from 'owa-mail-reading-pane-infobar/lib/utils/getInfoBarMessageViewState.locstring.json';
import {
    InfoIconText,
    AttachmentIconText,
    LikeIconText,
    EncryptionIconText,
} from './Charms.locstring.json';

const classNames = require('classnames');
const style = require('./Charms.scss');

export interface CharmsProps {
    message: ClientMessage;
    viewState: ItemViewState;
    instrumentationContext: InstrumentationContext;
    charmSize: CharmSize;
    hideAttachmentIcon?: boolean;
    hideCharmlessIcon?: boolean;
}

const CHARM_SIZE_CLASSES: { [key: number]: string } = {
    [CharmSize.size14]: style.size14,
    [CharmSize.size16]: style.size16,
};

export default observer(function Charms(props: CharmsProps) {
    const { message, viewState, instrumentationContext, charmSize } = props;
    const infoBarViewState = useComputed(
        () => createInfoBarViewState(message, [instrumentationContext], viewState),
        [message, viewState]
    );
    const importance = message.Importance;
    const hasAttachments = message.HasAttachments;
    const flagStatus: FlagStatus = message.Flag ? message.Flag.FlagStatus : 'NotFlagged';
    const isLiked = isMessageLiked(message);
    const iconClassName = CHARM_SIZE_CLASSES[charmSize];
    const redIconClassName = classNames(iconClassName, style.red);
    const isEncrypted = message.RightsManagementLicenseData;
    return (
        <>
            {/* Categories */}
            {/* Add Category Swatch in property Icons-  https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/1660 */}
            {/* InfoBars */}
            {!isEncrypted && hasCharmlessInfoBars(infoBarViewState) && (
                <Icon
                    className={iconClassName}
                    iconName={ControlIcons.Info}
                    ariaLabel={loc(InfoIconText)}
                />
            )}
            {/* Encryption */}
            {isEncrypted && (
                <Icon
                    className={iconClassName}
                    iconName={ControlIcons.Lock}
                    ariaLabel={loc(EncryptionIconText)}
                />
            )}

            {/* Importance */}
            {importance == 'High' && (
                <Icon
                    className={redIconClassName}
                    iconName={ControlIcons.Important}
                    ariaLabel={loc(infoHighImportance)}
                />
            )}
            {importance == 'Low' && (
                <Icon
                    className={iconClassName}
                    iconName={ControlIcons.Down}
                    ariaLabel={loc(infoLowImportance)}
                />
            )}
            {/* Attachments */}
            {hasAttachments && (
                <Icon
                    className={iconClassName}
                    iconName={ControlIcons.Attach}
                    ariaLabel={loc(AttachmentIconText)}
                />
            )}
            {/* Flag */}
            {flagStatus == 'Flagged' && (
                <Icon
                    className={redIconClassName}
                    iconName={ControlIcons.Flag}
                    ariaLabel={loc(infoFlagForFollowUp)}
                />
            )}
            {isLiked && (
                <Icon
                    className={iconClassName}
                    iconName={ControlIcons.Like}
                    ariaLabel={loc(LikeIconText)}
                />
            )}
        </>
    );
});
